import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { DataFileImportDto, DecryptionKeyDto, DocumentDto, MsisdnDto, ResultListDto, SampleValidationLine, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpDataFileImportService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/data-file-import', authService);
	}
	get(id: number):Observable<DataFileImportDto>{
		return super.doGet(true, `/${id}`);
	}
	getSamples(id: number):Observable<SampleValidationLine[]>{
		return super.doGet(true, `/${id}/samples`);
	}
	getList(pageNumber: number, pageSize: number):Observable<ResultListDto<DataFileImportDto>>{
		return super.doGet(true, `/?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	uploadCsvFile(file: any): Observable<HttpEvent<DataFileImportDto[]>>{
		return super.doUploadFile(true, `/upload_csv_file`, file);
	}
	doDownloadRejections(id: number): Observable<any> {
		return super.doDownloadFile(true, `/${id}/download/rejected`);
	}
	doDownloadOriginal(id: number):Observable<any> {
		return super.doDownloadFile(true, `/${id}/download/original`);
	}
	getDecryptionKey(id: number, password: string):Observable<DecryptionKeyDto>{
		return super.doPost(true, `/${id}/decryption_key`, password);
	}
}
